import { render, staticRenderFns } from "./PageConfig.vue?vue&type=template&id=1e76f6a8&scoped=true&"
import script from "./PageConfig.vue?vue&type=script&lang=js&"
export * from "./PageConfig.vue?vue&type=script&lang=js&"
import style0 from "./PageConfig.vue?vue&type=style&index=0&id=1e76f6a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e76f6a8",
  null
  
)

export default component.exports